import { Component, Host, h, Prop } from "@stencil/core";

import { ProductionStatus } from "./production-status-enum";

@Component({
    tag: "ux-iws-production-status",
    styleUrl: "production-status.scss",
    shadow: false,
})
export class StatusLabel {
    /** type of the status */
    @Prop() type: string;

    render() {
        const { type } = this;

        const getLabelColor = (type: string): string => {
            switch (type) {
                case ProductionStatus.OPEN:
                    return "grey";
                case ProductionStatus.CANCELED:
                    return "red";
                case ProductionStatus.IN_PRODUCTION:
                    return "orange";
                case ProductionStatus.COMPLETED:
                    return "green";
                default:
                    return "grey";
            }
        };

        return (
            <Host
                class={`ux-iws-production-status ux-text-status ux-text-status--${getLabelColor(
                    type
                )}`}
            >
                <ux-icon
                    class="ux-iws-production-status__icon"
                    name="circle-filled"
                />
                <div class="ux-iws-production-status__slot-container">
                    <slot />
                </div>
            </Host>
        );
    }
}
